export default __webpack_public_path__ + "static/11_29-ab3ceef726350edbfa8aefea26c8d6b8.png";